import React, { useState, useEffect } from "react";
import apiClient from "../services/apiClient";
import { useTranslation } from 'react-i18next';

const Comments = ({ storyId, chapterId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    apiClient
      .get(`/api/v1/stories/${storyId}/chapters/${chapterId}/comments`)
      .then((response) => setComments(response.data))
      .catch((error) => console.error("Error fetching comments:", error));
  }, [storyId, chapterId]);

  const handleAddComment = () => {
    apiClient
      .post(`api/v1/stories/${storyId}/chapters/${chapterId}/comments`, { content: newComment })
      .then((response) => {
        console.log(response.data);
        setComments((prev) => [...prev, response.data]);
        setNewComment("");
      })
      .catch((error) => console.error("Error adding comment:", error));
  };

  return (
    <div>
      <h3>{t('comments')}</h3>
      <ul>
        {comments.map((comment) => (
          <li key={comment.id}>
            <strong>{comment?.user?.email}</strong>: {comment.content}
          </li>
        ))}
      </ul>
      <textarea
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        placeholder={t('addYourComment')}
      ></textarea>
      <div>
        <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={handleAddComment}>{t('submitComment')}</button>
      </div>
    </div>
  );
};

export default Comments;